// Number of financial days in 1 year
export const FINANCIAL_DAYS_IN_YEAR = 252;

export const DAYS_IN_YEAR = 365;

// Key to save last lang picked by user.
export const LOCALE_KEY = "locale_" + process.env.VUE_APP_ORG_ID;
